var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"context-kebab-menu uk-flex-none"},[_c('div',{class:[
      'context-kebab-trigger',
      ("context-kebab-trigger--" + _vm.variant)
    ]},[_c('i',{staticClass:"fa-solid fa-ellipsis-vertical",attrs:{"alt":"Context Menu"}})]),_c('div',{class:[
      'context-kebab-dropdown',
      ("context-kebab-dropdown--elevation-" + _vm.elevation)
    ],attrs:{"uk-dropdown":_vm.options}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }